import { createFilePathUtils } from '@hidayahlab/academy-suite-corelib';

export const environment = process.env.ENV as
  | 'development'
  | 'production'
  | 'local';

export const apiEndpoint = process.env.NEXT_PUBLIC_API_ENDPOINT;
export const kamilDigitalApiEndPoint = process.env.KAMIL_DIGITAL_API_ENDPOINT;
export const assetsUrl = process.env.NEXT_PUBLIC_ASSETS_URL;
export const jwtSecret = process.env.JWT_SECRET;
export const resendApiKey = process.env.RESEND_API_KEY;
export const senderEmailAddress = process.env.SENDER_EMAIL_ADDRESS;
export const adminEmailAddress = process.env.ADMIN_EMAIL_ADDRESS;
export const appName = process.env.APP_NAME;
export const baseUrl = process.env.BASE_URL;
export const systemUserId = 0;
export const authTokenLocalStorageKey =
  process.env.NEXT_PUBLIC_AUTH_LOCAL_STORAGE_TOKEN_KEY;
export const gotipathLibraryId = process.env.NEXT_PUBLIC_GOTIPATH_LIBRARY_ID;

export const FilePathUtils = createFilePathUtils(
  assetsUrl || 'https://dev-assets.academysuite.xyz',
);
export const getIeltsTestAudioPath = (testId: number) =>
  `${assetsUrl || 'https://dev-assets.academysuite.xyz'}/uploads/ielts/tests/${testId}/audio`;

export const postHogApiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
export const postHogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

export const liveClassDurationInHours = 1;
export const voiceQuizExpiredBeforeLessonInHours = 2;
export const voiceQuizExpiredForLastLessonInDays = 2;
export const MAXIMUM_PROFILE_PIC_UPLOAD_LIMIT = 1 * 1024 * 1024;
